import { fetcher } from '@commenda/utils';

import {
  IIndirectTaxContentIngestionJobResponse,
  IIndirectTaxContentIngestionJobsResponse,
  IIndirectTaxContentIngestionRefreshParams,
  IIndirectTaxContentIngestionRefreshResponse,
} from './types';

const INDIRECT_TAX_CONTENT_INGESTION_BASE =
  'new-sales-tax/internal/content-ingestion';

function messageFromBody(body: { message?: unknown } | null, fallback: string) {
  const message = Array.isArray(body?.message)
    ? body.message.join(', ')
    : body?.message;

  return typeof message === 'string' && message ? message : fallback;
}

async function serverMessage(response: Response, fallback: string) {
  return messageFromBody(await response.json().catch(() => null), fallback);
}

export async function refreshContentIngestion({
  ingestionType,
}: IIndirectTaxContentIngestionRefreshParams): Promise<IIndirectTaxContentIngestionRefreshResponse> {
  const response = await fetcher(
    `${INDIRECT_TAX_CONTENT_INGESTION_BASE}/refresh`,
    {
      method: 'POST',
      body: { ingestionType },
    }
  );

  const data = await response.json().catch(() => null);

  if (!response.ok) {
    throw new Error(
      messageFromBody(data, 'Failed to queue the content refresh.')
    );
  }

  return data;
}

export async function fetchContentIngestionJob(
  jobId: string
): Promise<IIndirectTaxContentIngestionJobResponse> {
  const response = await fetcher(
    `${INDIRECT_TAX_CONTENT_INGESTION_BASE}/jobs/${encodeURIComponent(jobId)}`,
    {
      method: 'GET',
    }
  );

  if (!response.ok) {
    throw new Error(
      await serverMessage(
        response,
        'Failed to fetch the content ingestion job.'
      )
    );
  }

  return response.json();
}

export async function fetchContentIngestionJobs(
  limit?: number
): Promise<IIndirectTaxContentIngestionJobsResponse> {
  const query = limit ? `?limit=${limit}` : '';
  const response = await fetcher(
    `${INDIRECT_TAX_CONTENT_INGESTION_BASE}/jobs${query}`,
    {
      method: 'GET',
    }
  );

  if (!response.ok) {
    throw new Error(
      await serverMessage(
        response,
        'Failed to fetch the content ingestion history.'
      )
    );
  }

  return response.json();
}
